export const updateFilters = (levels) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'UPDATE_FILTERS',
      levels
    })
  }
}

export const updateTypes = (types) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'UPDATE_TYPES',
      types
    })
  }
}
